import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en";

i18n.use(initReactI18next).init({
  resources: {
    en
  },
  fallbackLng: "en",
  ns: ["translations"],
  defaultNS: "translations",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
    formatSeparator: ","
  }
});

export default i18n;
